import axios from 'axios';
import qs from 'qs';
import store from '../store/store';
import {
  _anly_seng_custom,
  _clear_user_info,
  _set_safe_verify_data,
  _show_login_modal,
} from '../store/Action';
import Util from './util';
import WEBROOM from '../store/WebRoom';
import WEBIM from '../store/WebNim';

/********创建实例********/
const service = axios.create();

/********请求参数处理********/
service.interceptors.request.use(async (request) => {
  const store_state = { ...store.getState() };
  request.baseURL = store_state.rootConfig.ctxPath;
  let df_param = {
    register: store_state.register,
    source: store_state.rootConfig.source,
    channelId: store_state.channelId,
    version: store_state.rootConfig.version,
    companyCode: store_state.rootConfig.companyCode,
    lang: store_state.rootConfig.lang || 'zh_CN',
    lang_area:
      store_state?.rootConfig?.lang === 'zh_CN'
        ? 'CN'
        : store_state.rootConfig.lang,
  };
  if (!request.params) request.params = {};
  if (request.method === 'post') {
    if (!request.data) request.data = {};
    request.params = { ...df_param, ...request.data };
  } else {
    request.params = { ...df_param, ...request.params };
  }
  store_state?.uid && (request.headers['uid'] = store_state.uid);
  store_state?.token && (request.headers['authorization'] = store_state.token);
  store_state?.channelId &&
    (request.headers['channelId'] = store_state.channelId || '');
  request.headers['source'] = store_state.rootConfig.source || 1;
  request.headers['version'] = store_state.rootConfig.version || '';
  request.headers['vnum'] = store_state.rootConfig.vnum || '';
  request.headers['lang'] = store_state.rootConfig.lang || 'zh_CN';
  request.headers['companyCode'] = store_state.rootConfig.companyCode;
  request.headers['appCode'] = store_state.rootConfig.companyCode;
  request.headers['appSubCode'] = 'DAIDAI';
  if (window?.century_setting?.os_type != null)
    request.headers['osType'] = window.century_setting.os_type; // 日志上报所需 操作系统类型
  const uuid = await Util.getReportUuid();
  if (uuid) request.headers['uuid'] = uuid; // 日志上报所需 日志本身的uuid
  const gid = Util.getReportParams('gid');
  const mac = Util.getReportParams('mac');
  const pcname = Util.getReportParams('pcname');
  const bootid = Util.getReportParams('bootid');
  if (gid) request.headers['gid'] = gid; // 日志上报所需 网吧电脑gid
  if (mac) request.headers['mac'] = mac; // 日志上报所需 网吧电脑mac
  if (pcname) request.headers['pcname'] = pcname; // 日志上报所需 网吧电脑名称
  if (bootid) request.headers['bootid'] = bootid; // 日志上报所需 网吧电脑bootid

  if (request.params && request.params.token && !request.params.noInToken) {
    request.headers['authorization'] = request.params.token;
    request?.params?.uid && (request.headers['uid'] = request.params.uid);
  }
  // 房间ID
  if (!request.params?.roomId) {
    if (
      request.params &&
      WEBROOM?.isInRoom &&
      WEBROOM?.conn &&
      WEBROOM?.roomid
    ) {
      request.headers['roomId'] = request?.params?.roomid ?? WEBROOM.roomid;
      request.params['roomId'] = request?.params?.roomid ?? WEBROOM.roomid;
    }
  }
  if (request.params && WEBROOM?.getMaster())
    request.headers['hostId'] = Util.$analyToUid(WEBROOM.getMaster()); // 日志上报所需 主持人ID

  delete request.params.isCrypto;
  request.headers['timestamp'] = Util.getNowTime();
  request.headers['X-Signature'] = await Util.cryptoParamsCode(
    request.headers,
    request.params
  );
  // todo 2022.03.25 noInToken 不使用传入的 token。因为二次授权导致 token 字段重名
  if (request.params && request.params.noInToken) {
    delete request.params.noInToken;
  }

  request.metadata = { startTime: Date.now() };

  if (request.method === 'post') {
    if (request.data.application === 'json') {
      request.data = { ...df_param, ...request.params };
      request.headers['Content-Type'] = 'application/json; charset=UTF-8';
    } else {
      request.data = qs.stringify({ ...df_param, ...request.params });
      request.headers['Content-Type'] =
        'application/x-www-form-urlencoded; charset=UTF-8';
    }
    delete request.params;
  } else {
    request.params = { ...df_param, ...request.params };
    request.headers['Content-Type'] = 'application/json; charset=UTF-8';
  }
  return request;
});

/********服务响应处理********/
service.interceptors.response.use(
  async (response) => {
    showRequestUrl(response.config);
    let {
      config: { baseURL, url, method, params, data },
    } = response;
    //数据异常日志
    if (response.data.code == 500) {
      if (typeof params == 'string') params = qs.parse(params);
      if (typeof data == 'string') data = qs.parse(data);
      const sendWarn = {
        url: baseURL + url,
        params: method == 'get' ? params : data,
      };
      sendWarn['message'] = response.statusText;
      sendWarn['data'] = response.data;
      _anly_seng_custom(1501, sendWarn);
    }
    //当前用户登录信息已失效, 需要重新登录
    else if (response.data.code === 401) {
      // window.location.href = '/index?' + window.location.search;
      _clear_user_info();
      _show_login_modal(); // 401 打开登录页
    }
    // 用户被封禁，展示封禁弹窗 todo 服务端返回错误状态有BUG，改为只处理部分接口 20230801
    /*else if (response.data.code === 3340) {
    _show_account_abnormal_modal(response.data);
  }*/
    else if (response?.data?.code === 5501) {
      // 极验
      if (response?.data?.data.sceneType != null) {
        WEBIM.events['OPEN_CAPTCHA_VERIFIED'] &&
          WEBIM.events['OPEN_CAPTCHA_VERIFIED'](response.data.data.sceneType);
      }
    } else if (response?.data?.code === 5503) {
      const store_state = { ...store.getState() };
      if (!store_state?.realAuthData) {
        store.dispatch({
          type: 'real_auth_data',
          data: { realAuthData: { ...response.data?.data, isTrigger: true } },
        });
      }
    } else if (response?.data?.code === 5506) {
      const store_state = { ...store.getState() };
      if (!store_state?.riskAuthData) {
        store.dispatch({
          type: 'risk_auth_data',
          data: { riskAuthData: { ...response.data?.data, isTrigger: true } },
        });
      }
    } else if (response?.data?.code === 5505) {
      // todo 用户验证完成后，手动再次执行
      // response.config.data = qs.parse(response.config.data);
      // _set_safe_verify_data(true, response.config);
      _set_safe_verify_data(true);
    }
    if (response.data.code !== 200) {
      let { config, data } = response;
      console.warn('接口异常：', {
        baseURL: config.baseURL,
        url: config.url,
        headers: config.headers,
        params: config.params,
        data,
      });
    }
    if (response?.data?.data) {
      response.data.data = await Util.decryptContent(
        response.data.data,
        response.config.url
      );
    }
    return response.data;
  },
  (error) => {
    console.error('error', error);
    let errorJSON = error.toJSON();
    let { code, message, config } = errorJSON;
    let { baseURL, url, method, params, data } = config;
    if (typeof params == 'string') params = qs.parse(params);
    if (typeof data == 'string') data = qs.parse(data);
    const sendError = {
      url: baseURL + url,
      message,
      params: method == 'get' ? params : data,
    };
    if (error.response) {
      sendError['message'] = error.response.statusText;
      sendError['data'] = error.response.data;
    }
    showRequestUrl(config);
    _anly_seng_custom(1500, sendError);
    console.error('接口异常：', errorJSON);
    return {
      code: code || 500,
      data: sendError.data || null,
      message: sendError.message || '服务异常，请稍后再试~',
    };
  }
);

function showRequestUrl(config) {
  if (!config || !config.metadata) return;
  config.metadata.endTime = Date.now();
  const { startTime, endTime } = config.metadata;
  const pathname = window.location.pathname;
  console.log(
    `=> ${config.method} ${config.url} ${endTime - startTime}ms page: ${pathname}`
  );
}

export default service;
